export default __webpack_public_path__ + "db4447b858fb17f83267bea40300f7b9.png";